import {withIMask} from './components/withIMask';
import {SpartanTextField} from './SpartanTextField';

export const SpartanZipCodeField = withIMask(SpartanTextField, {mask: '00000', lazy: true});
